import SDIcon from '../SDIcon'
import type { SDIconProps } from '../SDIcon'

const IconBan = ({ size = 16, color = 'currentColor', ...props }: SDIconProps) => (
  <SDIcon viewBox='0 0 24 24' size={size} color={color} aria-hidden='true' {...props}>
    <g fill='none' stroke='currentColor' strokeWidth='1.9' strokeLinecap='round' strokeLinejoin='round'>
      <circle cx='12' cy='12' r='9' />
      <path d='m5.7 5.7 12.6 12.6' />
    </g>
  </SDIcon>
)

export default IconBan
